// extracted by mini-css-extract-plugin
export default {"container":"styles_container__Z8wwn","block":"styles_block__vAguG","list":"styles_list__KtDtS","listItem":"styles_listItem__SsmHg"};